(function () {
  var APPS_SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycby51h1LHYVluN6o8tB3GrD9w1CqJkmFLpXiUZkSSFgi7iKvhGE_QQHpMEIbqzjNjgbUhg/exec";

  var FUNNEL_START_PAGES = {
    "/pages/quiz-start": "BPCold",
    "/pages/bpc-start-email": "BPCv2email",
    "/pages/bpc-start": "BPCv2",
    "/pages/nato-quiz-start-email": "Natoemail",
    "/pages/nato-quiz-start": "Natov2",
    "/pages/nato-quiz-start-2": "Natov3",
  };

  var SESSION_KEY = "quiz_session_id";
  var FUNNEL_KEY = "quiz_funnel";
  var OFFSET_KEY = "quiz_q_offset"; // how many questions came before this page

  function init() {
    var path = window.location.pathname.replace(/\/$/, "");

    if (FUNNEL_START_PAGES[path]) {
      // Start page: reset session, offset starts at 0 (Q1 is really Q1)
      sessionStorage.setItem(FUNNEL_KEY, FUNNEL_START_PAGES[path]);
      sessionStorage.setItem(OFFSET_KEY, "0");
      sessionStorage.setItem(
        SESSION_KEY,
        "sess_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9),
      );
    } else if (sessionStorage.getItem(FUNNEL_KEY)) {
      // Sub-page: start page had 1 question, so offset = 1
      // Only set it once — don't overwrite if already set to something else
      if (!sessionStorage.getItem(OFFSET_KEY)) {
        sessionStorage.setItem(OFFSET_KEY, "1");
      }
    }

    var funnel = sessionStorage.getItem(FUNNEL_KEY);
    if (!funnel) return;

    var sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId =
        "sess_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem(SESSION_KEY, sessionId);
    }

    var offset = parseInt(sessionStorage.getItem(OFFSET_KEY) || "0", 10);

    if (!document.querySelector(".col_quiz_inner")) return;

    // Track first visible question on page load
    var visible = document.querySelector(".col_quiz_inner.visible");
    if (visible) {
      trackSeen(funnel, sessionId, visible.getAttribute("data-index"), offset);
    }

    // Watch for newly visible questions
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var el = mutation.target;
        if (el.classList.contains("visible")) {
          trackSeen(funnel, sessionId, el.getAttribute("data-index"), offset);
        }
      });
    });

    document.querySelectorAll(".col_quiz_inner").forEach(function (el) {
      observer.observe(el, { attributes: true, attributeFilter: ["class"] });
    });

    initAnswerTracking(funnel, sessionId, offset);
  }

  // ── Question seen tracking ─────────────────────────────────────────────────

  function trackSeen(funnel, sessionId, rawIndex, offset) {
    if (!rawIndex) return;
    var localIndex = parseInt(rawIndex, 10);
    var trackIndex = localIndex + offset; // global question number across pages

    // Dedup uses local index + pathname so back-nav doesn't re-fire
    var dedupKey = "ht_q_" + window.location.pathname + "_" + localIndex;
    if (sessionStorage.getItem(dedupKey)) return;
    sessionStorage.setItem(dedupKey, "1");

    send({
      type: "seen",
      funnel: funnel,
      sessionId: sessionId,
      question: trackIndex,
    });
  }

  // ── Answer tracking ────────────────────────────────────────────────────────

  function initAnswerTracking(funnel, sessionId, offset) {
    document.addEventListener("click", function (e) {
      // Single-select grid answer
      var gridBlock = e.target.closest(".col_quiz_grid_block");
      if (gridBlock) {
        var inner = gridBlock.closest(".col_quiz_inner");
        if (!inner) return;
        var answerEl = gridBlock.querySelector(".col_quiz_answer");
        var answer = answerEl ? answerEl.textContent.trim() : "";
        if (answer)
          sendAnswer(
            funnel,
            sessionId,
            inner.getAttribute("data-index"),
            offset,
            answer,
          );
        return;
      }

      // Image-grid answer
      var imageBlock = e.target.closest(".col_quiz__image_grid_block");
      if (imageBlock) {
        var inner = imageBlock.closest(".col_quiz_inner");
        if (!inner) return;
        var answerEl = imageBlock.querySelector(".col_quiz_answer");
        var answer = answerEl
          ? answerEl.textContent.trim()
          : imageBlock.getAttribute("data") || "";
        if (answer)
          sendAnswer(
            funnel,
            sessionId,
            inner.getAttribute("data-index"),
            offset,
            answer,
          );
        return;
      }

      // Continue / submit button
      var btn = e.target.closest(".col_quiz_btn");
      if (btn && !btn.classList.contains("disabled")) {
        var inner = btn.closest(".col_quiz_inner");
        if (!inner) return;
        var answer = extractButtonAnswer(inner, btn);
        if (answer)
          sendAnswer(
            funnel,
            sessionId,
            inner.getAttribute("data-index"),
            offset,
            answer,
          );
      }
    });
  }

  function extractButtonAnswer(inner, btn) {
    // Email step
    if (btn.getAttribute("data") === "email_step") {
      var emailInput = inner.querySelector(".col_quiz_email_collection__js");
      return emailInput && emailInput.value.indexOf("@") !== -1
        ? emailInput.value.trim()
        : "";
    }

    // Multi-select
    var activeItems = inner.querySelectorAll(
      ".multiSelect.active .col_quiz_answer",
    );
    if (activeItems.length > 0) {
      return Array.from(activeItems)
        .map(function (el) {
          return el.textContent.trim();
        })
        .join(", ");
    }

    // Age input
    var ageInput = inner.querySelector(".col_quiz_age_field.age");
    if (ageInput && ageInput.value) return ageInput.value.trim();

    // Weight inputs
    var weightInput = inner.querySelector(".col_quiz_age_field.weight");
    var desiredInput = inner.querySelector(
      ".col_quiz_age_field.desired_weight",
    );
    if (weightInput && weightInput.value) {
      var unit = inner.querySelector(".col_quiz_unit_btn.active");
      var unitLabel = unit ? unit.getAttribute("data-unit") : "";
      var result = weightInput.value.trim();
      if (desiredInput && desiredInput.value)
        result += " / desired: " + desiredInput.value.trim();
      if (unitLabel) result += " (" + unitLabel + ")";
      return result;
    }

    // Height inputs
    var metricInput = inner.querySelector(".col_quiz_age_field.metric");
    if (metricInput && metricInput.value)
      return metricInput.value.trim() + " cm";
    var ftInput = inner.querySelector(".imperial-ft");
    var inInput = inner.querySelector(".imperial-in");
    if (ftInput && ftInput.value) {
      return ftInput.value + "ft " + (inInput ? inInput.value : "0") + "in";
    }

    return ""; // Text/info screens — nothing to track
  }

  function sendAnswer(funnel, sessionId, rawIndex, offset, answer) {
    if (!rawIndex || !answer) return;
    var trackIndex = parseInt(rawIndex, 10) + offset;
    send({
      type: "answer",
      funnel: funnel,
      sessionId: sessionId,
      question: trackIndex,
      answer: answer,
    });
  }

  // ── Shared send ────────────────────────────────────────────────────────────

  function send(data) {
    data.timestamp = new Date().toISOString();
    var params = new URLSearchParams(data);
    fetch(APPS_SCRIPT_URL + "?" + params.toString(), { mode: "no-cors" }).catch(
      function () {},
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
